import { render, staticRenderFns } from "./ExcessHospital.vue?vue&type=template&id=c70f9e7c&scoped=true"
import script from "./ExcessHospital.vue?vue&type=script&lang=js"
export * from "./ExcessHospital.vue?vue&type=script&lang=js"
import style0 from "./ExcessHospital.vue?vue&type=style&index=0&id=c70f9e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70f9e7c",
  null
  
)

export default component.exports